<template>
  <v-card outlined height="100%">
    <v-card-actions class="py-0">
      <v-toolbar dense flat>
        <v-btn outlined @click="(showTemplate = true) && (template = {}) && (istNeu = true)"
          ><v-icon>add</v-icon>Hinzufügen</v-btn
        >
      </v-toolbar>
    </v-card-actions>
    <v-divider></v-divider>
    <v-card-text class="ma-0 pa-0">
      <v-simple-table fixed-header dense height="100%">
        <thead>
          <tr>
            <th width="40px">ID</th>
            <th>Name</th>
            <th>Kategorie</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in templates"
            :key="index"
            @click="(showTemplate = true) && (template = item) && (istNeu = false)"
          >
            <td>{{ item.id }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.kategorie }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>

    <v-dialog v-model="showTemplate" width="80%" :fullscreen="$vuetify.breakpoint.smAndDown" persistent scrollable>
      <v-card>
        <v-card-title>
          Template bearbeiten - {{ template.name }}
          <v-spacer></v-spacer>
          <v-btn icon @click="showTemplate = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-2">
          <v-row>
            <v-col cols="6">
              <v-text-field outlined v-model="template.name" label="Templatename"></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-select
                outlined
                v-model="template.kategorie"
                :items="templateKategorien"
                label="Templatekategorie"
              ></v-select>
            </v-col>
            <v-col cols="6">
              <v-textarea outlined v-model="template.html" label="Inhalt" rows="25"></v-textarea>
            </v-col>
            <v-col cols="6">
              <v-card outlined>
                <v-sheet
                  ref="cardText"
                  class="pa-4"
                  style="overflow-y: auto"
                  max-height="700"
                  v-html="template.html"
                ></v-sheet>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn icon @click="deleteTemplate()"><v-icon>delete</v-icon></v-btn>
          <v-spacer></v-spacer>
          <v-btn text class="primary" @click="updateTemplates()">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
  export default {
    data() {
      return {
        showTemplate: false,
        template: {},
        istNeu: false,
        templateKategorien: ["Mail", "Rechnung", "Brief"],
      };
    },
    computed: {
      templates() {
        return this.$store.getters["einstellungen/einstellung"]("templates").templates;
      },
    },
    methods: {
      deleteTemplate() {
        let templates = this.$store.getters["einstellungen/einstellung"]("templates");
        templates.templates.splice(templates.templates.indexOf(this.template), 1);
        this.$store.dispatch("einstellungen/updateEinstellungData", templates);
        this.showTemplate = false;
        this.template = {};
      },
      updateTemplates() {
        let templates = this.$store.getters["einstellungen/einstellung"]("templates");
        if (!templates.templates) {
          templates.templates = [];
        }
        if (this.istNeu) {
          let id = 1;
          templates.templates.forEach((item) => {
            if (parseInt(item.id) >= id) {
              id = parseInt(item.id) + 1;
            }
          });
          this.template.id = id;
          templates.templates.push(this.template);
        }
        this.$store.dispatch("einstellungen/updateEinstellungData", templates);
        this.showTemplate = false;
        this.template = {};
      },
    },
  };
</script>



// WEBPACK FOOTER //
// Templates.vue?a93e2dec